function LoginSession() {

    var self = this;

    // Private Variables
    var timeoutLogoutPopup;
    var timeoutLogoutFinal;
    var logoutPopupWait = 115;  // in minutes
    var logoutFinalWait = 5; // in minutes
    //var logoutPopupWait = 0.05; // DEBUG in minutes
    //var logoutFinalWait = 0.1; // DEBUG in minutes
    var isLogoutPopupDisplayed = false;

    var previousX = 0;
    var previousY = 0;

    // Observables
    self.timeLeft = ko.observable(logoutFinalWait * 60);

    // Computeds
    self.timeLeftText = ko.computed(function() {
        return "Auto-logout in: " + moment("2015-01-01").startOf("day").seconds(self.timeLeft()).format("mm:ss");
    });

    // Event Handlers
    self.continueSessionClick = function() {
        cccApp.closePopup();
    };

    // Private Functions
    function resetLogoutPopupTimer(event) {
        if (isLogoutPopupDisplayed !== true && !isFakeMouseMovement(event)) {
            clearTimeout(timeoutLogoutPopup);
            timeoutLogoutPopup = setTimeout(function () { checkSessionLoggedIn(); }, 60000 * logoutPopupWait);
        }
    }

    // Chrome and IE sometimes trigger mousemove events when the mouse isn't moving
    function isFakeMouseMovement(event) {
        if (event instanceof MouseEvent) {
            if (event.pageX === previousX && event.pageY === previousY) {
                return true;
            }
            previousX = event.pageX;
            previousY = event.pageY;
        }
        return false;
    }

    function checkSessionLoggedIn() {
        cccApp.api.get({
            url: "service/status/validatesession",
            success: function(result) {
                if (result.error && result.error.code === cccApp.api.codes.SUCC_Success) {
                    showLogoutPopup();
                } else {
                    window.location.href = "/logout";
                }
            },
            error: function() {
                showLogoutPopup();
            }
        });
    }

    function showLogoutPopup() {
        isLogoutPopupDisplayed = true;

        cccApp.openPopup("logout-popup", {
            afterClose: function () { continueSession(); }
        });

        timeoutLogoutFinal = setTimeout(function () { autoLogoutCheck(); }, 1000);
    }

    function continueSession() {
        isLogoutPopupDisplayed = false;
        clearTimeout(timeoutLogoutFinal);
        self.timeLeft(logoutFinalWait * 60);
        resetLogoutPopupTimer();
    }

    function autoLogoutCheck() {
        if (self.timeLeft() <= 0) {
            window.location.href = "/logout";
            return;
        }

        self.timeLeft(self.timeLeft() - 1);
        timeoutLogoutFinal = setTimeout(function () { autoLogoutCheck(); }, 1000);
    }

    //Initialisation
    document.onkeypress = resetLogoutPopupTimer;
    document.onmousemove = resetLogoutPopupTimer;
    resetLogoutPopupTimer();
}